import { render } from "./choiceApi.vue?vue&type=template&id=75d67e0f&scoped=true"
import script from "./choiceApi.vue?vue&type=script&lang=js"
export * from "./choiceApi.vue?vue&type=script&lang=js"

import "./choiceApi.vue?vue&type=style&index=0&id=75d67e0f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d67e0f"]])

export default __exports__